import JobDetailsCard from 'components/pages/jobs/jobdetails/JobDetailsCard';
import Spinner from '@core/components/spinner/Spinner';

import { useQuery } from 'react-query';
import { jobsJob } from 'services/pharmaJobs';

import classes from './JobDetails.module.scss';


const JobDetails = ({ activeJob, toast }) => {

    const { data, isLoading } = useQuery(
        ['job-board-job', activeJob],
        () => jobsJob.GET(activeJob),
        {
            refetchOnMount: true
        }
    );

    return !isLoading && activeJob && data?.data ? (
        <JobDetailsCard data={data} toast={toast} />
    ) : (
        <div className={classes['loading']}>
            <Spinner />
        </div>
    );
};

export default JobDetails;